<script setup lang="ts">
import { Tint } from "~/components/clarity-ui/Tint";
import { useProductEShopSetConfigurator } from "~/composables/shop/useProductEShopSetConfigurator";
import CommonLabel from "~/templates/components/CommonLabel.vue";

const { eShopSet, hasBestPrice } = await useProductEShopSetConfigurator();
</script>

<template>
  <div>
    <div v-if="hasBestPrice" class="flex items-center gap-2 text-2xl xl:text-3xl">
      <SharedPrice class="font-medium" discounted :value="eShopSet?.eshopSetPriceTotal" />
      <Tint><SharedPrice strikethrough :value="eShopSet?.bestEshopPriceFromHistory" /></Tint>
    </div>
    <SharedPrice
      v-else
      :value="eShopSet?.eshopSetPriceTotal"
      class="text-2xl font-medium xl:text-3xl"
    />
    <Tint class="mt-1 text-sm" tag="p">
      <CommonLabel path="BWF/shop/productDetailPage/plus" />&nbsp;<CommonLabel
        path="BWF/shop/checkout/cart/taxes"
      />
    </Tint>
  </div>
</template>
